import { MBSentry } from './index';

/*
    This reducer does nothing except for
    logging all redux actions to Sentry
*/
export function sentryListenerReducer(state = {}, action: MBAction) {
  MBSentry.breadcrumb({
    message: action.type,
    category: 'redux',
    data: {
      type: action.type,
    },
  });
  return state;
}
